var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[(_vm.error)?_c('div',[_vm._v(" LinkedIn Auth error: "+_vm._s(_vm.error)+" ")]):_c('div',[_vm._v(" Authenticate with LinkedIn... Please wait... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }